export default __webpack_public_path__ + "static/media/newblp_History_sel.e5a798e7.svg";